import { observable, when } from 'mobx';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import FeatureFlagStore from '../stores/FeatureFlagStore';
import GaDataStore from '../stores/GaDataStore';

export type ABType = 'A' | 'B';

export interface ABTestProps {
  name: string;
  componentA?: React.ReactChild | React.ReactChild[] | JSX.Element[];
  componentB?: React.ReactChild | React.ReactChild[] | JSX.Element[];
  featureFlagStore?: FeatureFlagStore;
}

@observer
class ABTestWrapper extends Component<ABTestProps> {
  @observable accessor featureFlagStore = this.props.featureFlagStore;

  componentDidMount() {
    if (!window.telia.abTests) {
      window.telia.abTests = {};
    }
    when(
      () => this.featureFlagStore.isInitialized,
      () => {
        const { name } = this.props;
        const value = this.getValue(name);
        GaDataStore.pushABTestEvent(name, value);
        window.telia.abTests[name] = value;
      },
      {}
    );
  }

  public render() {
    const { componentA, componentB, name, featureFlagStore } = this.props;
    if (!featureFlagStore.isInitialized) {
      return null;
    }
    return this.getValue(name) === 'A' ? componentA : componentB;
  }

  public getValue(key: string): ABType {
    return this.props.featureFlagStore.isEnabled(key) ? 'A' : 'B';
  }
}

export default inject('featureFlagStore')(ABTestWrapper);
